import React from 'react';
import './SuccessfullyApplied.css';
import { useNavigate } from 'react-router-dom';

const SuccessfullyApplied: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="successfully-applied">
      <div className="success-content">
        <h1>Successfully Applied!</h1>
        <p>Your application has been submitted successfully.</p>
        <button 
          className="back-button"
          onClick={() => navigate('/playground')}
        >
          Back to Playground
        </button>
      </div>
    </div>
  );
};

export default SuccessfullyApplied; 